import { render } from "./DocuSignMain.vue?vue&type=template&id=5bb00819&scoped=true&lang=pug"
import script from "./DocuSignMain.vue?vue&type=script&lang=js"
export * from "./DocuSignMain.vue?vue&type=script&lang=js"

import "./DocuSignMain.vue?vue&type=style&index=0&id=5bb00819&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb00819"]])

export default __exports__